import type { CataloguePlan, PlanStep } from "@models/access";

const FINISHED: PlanStep["status"][] = ["done", "skipped"];

/** The step to run next (core runs them strictly in order), `null` once every step finished. */
export const currentStep = (plan: CataloguePlan): number | null =>
  plan.steps.find((s) => !FINISHED.includes(s.status))?.n ?? null;

/** Users holding any role the plan changes, counted once per role (global counts). */
export const planUsersAffected = (plan: CataloguePlan): number => {
  const roles = new Map<string, number>();
  plan.steps.forEach((s) => s.roles.forEach((r) => roles.set(r.id, r.assignedUsers)));
  return [...roles.values()].reduce((sum, n) => sum + n, 0);
};

/** One line for what a step did: core's skip reason, or its result as compact JSON. */
export const stepResultText = (result: PlanStep["result"]): string | null => {
  if (!result) return null;
  if (typeof result.reason === "string") return result.reason;
  return JSON.stringify(result);
};
